import { useState } from 'react'
import { signIn, signUp, supabase } from '../lib/supabase'

export default function AuthPage() {
  const [mode, setMode]   = useState('login')
  const [form, setForm]   = useState({ name: '', email: '', password: '' })
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [done, setDone]   = useState(false)
  const [resetSent, setResetSent] = useState(false)

  const set = k => e => setForm(f => ({ ...f, [k]: e.target.value }))

  const googleLogin = async () => {
    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: 'https://paisatrack.vijaykumarbhoyar.com'
      }
    })
    if (error) setError(error.message)
  }

  const submit = async () => {
    setError(''); setLoading(true)
    try {
      if (mode === 'login') {
        const { error } = await signIn(form.email, form.password)
        if (error) throw error
      } else if (mode === 'signup') {
        if (!form.name.trim()) throw new Error('Please enter your name')
        const { error } = await signUp(form.email, form.password, form.name)
        if (error) throw error
        setDone(true)
      } else if (mode === 'forgot') {
        const { error } = await supabase.auth.resetPasswordForEmail(form.email, {
          redirectTo: 'https://paisatrack.vijaykumarbhoyar.com'
        })
        if (error) throw error
        setResetSent(true)
      }
    } catch (e) {
      setError(e.message)
    } finally {
      setLoading(false)
    }
  }

  if (done) return (
    <div style={styles.wrap}>
      <div style={styles.card}>
        <div style={styles.logo}>✓</div>
        <h2 style={styles.title}>Check your email</h2>
        <p style={styles.sub}>We sent a confirmation link to <strong>{form.email}</strong>. Click it, then come back and log in.</p>
        <button style={styles.btn} onClick={() => { setMode('login'); setDone(false) }}>Go to login</button>
      </div>
    </div>
  )

  if (resetSent) return (
    <div style={styles.wrap}>
      <div style={styles.card}>
        <div style={styles.logo}>📧</div>
        <h2 style={styles.title}>Reset link sent!</h2>
        <p style={styles.sub}>Check your email at <strong>{form.email}</strong> for a password reset link.</p>
        <button style={styles.btn} onClick={() => { setMode('login'); setResetSent(false) }}>Back to login</button>
      </div>
    </div>
  )

  return (
    <div style={styles.wrap}>
      <div style={styles.card}>
        <div style={styles.logo}>₹</div>
        <h1 style={styles.brand}>PaisaTrack</h1>
        <p style={styles.tagline}>Know where every rupee went.</p>

        {/* Google login button */}
        {mode !== 'forgot' && (
          <>
            <button style={styles.googleBtn} onClick={googleLogin}>
              <svg width="18" height="18" viewBox="0 0 18 18" style={{ marginRight: 8 }}>
                <path fill="#4285F4" d="M16.51 8H8.98v3h4.3c-.18 1-.74 1.48-1.6 2.04v2.01h2.6a7.8 7.8 0 0 0 2.38-5.88c0-.57-.05-.66-.15-1.18z"/>
                <path fill="#34A853" d="M8.98 17c2.16 0 3.97-.72 5.3-1.94l-2.6-2a4.8 4.8 0 0 1-7.18-2.54H1.83v2.07A8 8 0 0 0 8.98 17z"/>
                <path fill="#FBBC05" d="M4.5 10.52a4.8 4.8 0 0 1 0-3.04V5.41H1.83a8 8 0 0 0 0 7.18l2.67-2.07z"/>
                <path fill="#EA4335" d="M8.98 4.18c1.17 0 2.23.4 3.06 1.2l2.3-2.3A8 8 0 0 0 1.83 5.4L4.5 7.49a4.77 4.77 0 0 1 4.48-3.3z"/>
              </svg>
              Continue with Google
            </button>

            <div style={styles.divider}>
              <span style={styles.dividerLine}/>
              <span style={styles.dividerText}>or</span>
              <span style={styles.dividerLine}/>
            </div>
          </>
        )}

        {mode !== 'forgot' && (
          <div style={styles.toggle}>
            <button style={{ ...styles.toggleBtn, ...(mode === 'login' ? styles.toggleActive : {}) }} onClick={() => setMode('login')}>Log in</button>
            <button style={{ ...styles.toggleBtn, ...(mode === 'signup' ? styles.toggleActive : {}) }} onClick={() => setMode('signup')}>Sign up</button>
          </div>
        )}

        {mode === 'forgot' && (
          <p style={{ fontSize: 14, color: '#888', marginBottom: 16 }}>Enter your email and we'll send a reset link.</p>
        )}

        {mode === 'signup' && (
          <input style={styles.input} placeholder="Your name" value={form.name} onChange={set('name')} />
        )}
        <input style={styles.input} placeholder="Email" type="email" value={form.email} onChange={set('email')} />
        {mode !== 'forgot' && (
          <input style={styles.input} placeholder="Password" type="password" value={form.password} onChange={set('password')}
            onKeyDown={e => e.key === 'Enter' && submit()} />
        )}

        {error && <p style={styles.error}>{error}</p>}

        <button style={{ ...styles.btn, opacity: loading ? 0.6 : 1 }} onClick={submit} disabled={loading}>
          {loading ? 'Please wait…' : mode === 'login' ? 'Log in' : mode === 'signup' ? 'Create account' : 'Send reset link'}
        </button>

        {mode === 'login' && (
          <button style={styles.forgotBtn} onClick={() => { setMode('forgot'); setError('') }}>
            Forgot password?
          </button>
        )}
        {mode === 'forgot' && (
          <button style={styles.forgotBtn} onClick={() => { setMode('login'); setError('') }}>
            Back to login
          </button>
        )}
      <a href="/privacy" style={{display:'block',textAlign:'center',marginTop:16,fontSize:12,color:'#bbb',textDecoration:'none'}}>Privacy Policy</a>
      </div>
    </div>
  )
}

const styles = {
  wrap:        { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F7F4EF', padding: '1rem' },
  card:        { background: '#fff', borderRadius: 20, padding: '2.5rem 2rem', width: '100%', maxWidth: 400, boxShadow: '0 4px 40px rgba(0,0,0,0.08)' },
  logo:        { width: 56, height: 56, borderRadius: 16, background: '#1A1A2E', color: '#E8C547', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 28, fontWeight: 700, marginBottom: 12 },
  brand:       { fontSize: 26, fontWeight: 700, color: '#1A1A2E', margin: '0 0 4px', letterSpacing: '-0.5px' },
  tagline:     { fontSize: 14, color: '#888', marginBottom: 24 },
  googleBtn:   { display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', padding: '12px', border: '1.5px solid #E8E4DC', borderRadius: 10, fontSize: 15, fontWeight: 500, cursor: 'pointer', background: '#fff', color: '#333', marginBottom: 16 },
  divider:     { display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 },
  dividerLine: { flex: 1, height: 1, background: '#E8E4DC', display: 'block' },
  dividerText: { fontSize: 13, color: '#aaa' },
  toggle:      { display: 'flex', background: '#F7F4EF', borderRadius: 10, padding: 4, marginBottom: 20 },
  toggleBtn:   { flex: 1, padding: '8px', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 14, background: 'transparent', color: '#888', fontWeight: 500 },
  toggleActive:{ background: '#fff', color: '#1A1A2E', boxShadow: '0 1px 4px rgba(0,0,0,0.1)' },
  input:       { display: 'block', width: '100%', padding: '12px 14px', border: '1.5px solid #E8E4DC', borderRadius: 10, fontSize: 15, marginBottom: 12, outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit', background: '#FAFAF8', color: '#1A1A2E' },
  btn:         { width: '100%', padding: '13px', background: '#1A1A2E', color: '#E8C547', border: 'none', borderRadius: 10, fontSize: 15, fontWeight: 600, cursor: 'pointer', marginTop: 4 },
  error:       { color: '#C0392B', fontSize: 13, marginBottom: 10, padding: '8px 12px', background: '#FDF0EE', borderRadius: 8 },
  sub:         { fontSize: 14, color: '#555', lineHeight: 1.6, marginBottom: 20 },
  title:       { fontSize: 20, fontWeight: 700, color: '#1A1A2E', marginBottom: 8 },
  forgotBtn:   { display: 'block', width: '100%', marginTop: 12, background: 'none', border: 'none', color: '#888', fontSize: 13, cursor: 'pointer', textAlign: 'center' },
}
